module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "part01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('strong', [_vm._v("Part 1")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Forgiveness is based on the fact that there is no adequate form of revenge.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARLES")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EWMAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 84
// module chunks = 0